import { render, staticRenderFns } from "./col-question.vue?vue&type=template&id=609422a2"
import script from "./col-question.vue?vue&type=script&lang=js"
export * from "./col-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports